import { type } from '@/utils/type'

export const UI_CLOSE_SNACKBAR = type('UI_CLOSE_SNACKBAR')
export const UI_ADD_SNACK_MESSAGE = type('UI_ADD_SNACK_MESSAGE')

export const UI_SET_CONTENT_HEIGHT = type('UI_SET_CONTENT_HEIGHT')
export const UI_SET_RIGHT_DRAWER_OPEN = type('UI_SET_RIGHT_DRAWER_OPEN')
export const UI_SET_RIGHT_DRAWER_ENABLE = type('UI_SET_RIGHT_DRAWER_ENABLE')

export const UI_SET_ALLERGENE_VISIBLITY = type('UI_SET_ALLERGENE_VISIBLITY')
export const UI_SET_CART_VISIBLITY = type('UI_SET_CART_VISIBLITY')

export const UI_SET_SEARCH_SEJOUR = type('UI_SET_SEARCH_SEJOUR')
export const UI_SET_SORT_SEJOUR_DESC = type('UI_SET_SORT_SEJOUR_DESC')
export const UI_SET_SORT_SEJOUR_BY = type('UI_SET_SORT_SEJOUR_BY')

export const UI_SET_SEARCH_USER = type('UI_SET_SEARCH_USER')
export const UI_SET_SORT_USER_DESC = type('UI_SET_SORT_USER_DESC')
export const UI_SET_SORT_USER_BY = type('UI_SET_SORT_USER_BY')

export const UI_SET_SEARCH_COMMANDE = type('UI_SET_SEARCH_COMMANDE')
export const UI_SET_SORT_COMMANDE_DESC = type('UI_SET_SORT_COMMANDE_DESC')
export const UI_SET_SORT_COMMANDE_BY = type('UI_SET_SORT_COMMANDE_BY')

export const UI_SET_SEARCH_MAIL_TEMPLATE = type('UI_SET_SEARCH_MAIL_TEMPLATE')
export const UI_SET_SORT_MAIL_TEMPLATE_DESC = type('UI_SET_SORT_MAIL_TEMPLATE_DESC')
export const UI_SET_SORT_MAIL_TEMPLATE_BY = type('UI_SET_SORT_MAIL_TEMPLATE_BY')

export const UI_SET_SEARCH_MAIL_SKIN = type('UI_SET_SEARCH_MAIL_SKIN')
export const UI_SET_SORT_MAIL_SKIN_DESC = type('UI_SET_SORT_MAIL_SKIN_DESC')
export const UI_SET_SORT_MAIL_SKIN_BY = type('UI_SET_SORT_MAIL_SKIN_BY')

export const UI_SET_PRINT_MODE = type('UI_SET_PRINT_MODE')

